// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col_text[data-v-8991f284]{text-align:center}.editable-row-operations a[data-v-8991f284]{margin-right:8px}", ""]);
// Exports
module.exports = exports;
